import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import {
  abandonedCheckoutsApi,
  type AbandonedCheckoutListParams,
} from '../api/abandoned-checkouts-api';

import { abandonedCheckoutKeys } from './abandoned-checkout-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function abandonedCheckoutListQueryOptions(
  storeId: string,
  params: AbandonedCheckoutListParams,
) {
  return queryOptions({
    queryKey: abandonedCheckoutKeys.list(storeId, params),
    queryFn: () => abandonedCheckoutsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useAbandonedCheckouts(storeId: string, params: AbandonedCheckoutListParams) {
  return useQuery(abandonedCheckoutListQueryOptions(storeId, params));
}
